import './config/sentry';  // Must be FIRST import — initializes before anything else
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.tsx'

function FallbackUI() {
  return (
    <div style={{ padding: 40, textAlign: 'center', color: '#fff' }}>
      <h1>Something went wrong</h1>
      <p>We've been notified and are looking into it.</p>
      <button onClick={() => window.location.reload()}>Reload Page</button>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<FallbackUI />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
